<div class="modal" appNoRightClick>
  <!-- <div class="modal__container"> -->
  <div [ngClass]="revisedUrl ? 'modal__container_2' : 'modal__container'">
    <h3 *ngIf="title">{{ title }}</h3>
    <i *ngIf="subtitle">{{ subtitle }}</i>
    <div modal-host></div>
  </div>
</div>
